import { useProductDetails } from "./useProductDetails";

export const useProductCharacteristics = (productId: string) => {
  const {
    data: productDetails,
    isLoading,
    isError,
  } = useProductDetails(productId);

  return {
    data: productDetails?.productCharacteristics ?? [],
    isLoading,
    isError,
  };
};
